// 开发环境接口配置
const APIURl = 'http://localhost:5000'

module.exports = {
  pageTitle: process.env.VUE_APP_TITLE,
  //API地址
  APIURl: APIURl,
  //请求超时时间
  timeout: process.env.NODE_ENV === 'development' ? 1000000 : 1000000,
  //Socket地址
  WebSocketUrl: process.env.NODE_ENV === 'development' ? APIURl.replace('http', 'ws') + '/api/message/websocket' : process.env.VUE_APP_BASE_WSS,
  //附件上传地址
  comUploadUrl: process.env.VUE_APP_BASE_API + '/api/file/Uploader',
  //网站地址
  comUrl: process.env.VUE_APP_BASE_API,
  //是否私有LOGO
  privateIcon: process.env.VUE_APP_TITLE === 'QiTu' ? false : true,
  // 本地文件预览
  filePreviewServer: process.env.NODE_ENV === 'development' ? 'http://localhost:30090' : process.env.VUE_APP_BASE_API + '/FileServer',
  // 大屏应用前端路径
  dataV: process.env.NODE_ENV === 'development' ? 'http://localhost:30033/DataV' : process.env.VUE_APP_BASE_API + '/DataV',
  // 数据报表接口-java boot
  reportServer: process.env.NODE_ENV === 'development' ? 'http://localhost:30030' : process.env.VUE_APP_BASE_API + '/ReportServer',
  // 数据报表接口-java cloud
  // reportServer: process.env.NODE_ENV === 'development' ? 'http://localhost:30000' : process.env.VUE_APP_BASE_API,
  // 报表前端
  report: process.env.NODE_ENV === 'development' ? 'http://localhost:8200' : process.env.VUE_APP_BASE_API + '/Report'
}
